//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import AuthType from '@apis/auth/models/AuthType';

import { amplifyConfig } from 'app/initialization/amplify/config';
import { ICognitoStateData } from 'app/initialization/routing/routingModels';

export function runOauthForProvider(
  provider: 'Google' | AuthType,
  stateParam: ICognitoStateData,
  loginHint?: string,
) {
  // The login_hint provides a way for system to pre-populated the email address on the sign-in form.
  // Doing that means that all the user has to do to log on is type in their password.
  // login_hint works with most of the OAuth providers like Okta, Google, etc.
  const loginHintParam = loginHint ? `&login_hint=${loginHint}` : '';

  const url =
    `https://${amplifyConfig.Auth.oauth.domain}/oauth2/authorize` +
    '?response_type=code' +
    `&client_id=${amplifyConfig.aws_user_pools_web_client_id}` +
    `&identity_provider=${provider}` +
    `&state=${encodeURIComponent(JSON.stringify(stateParam))}` +
    `&redirect_uri=${encodeURIComponent(
      amplifyConfig.Auth.oauth.redirectSignIn,
    )}${loginHintParam}`;

  window.location.assign(url);
}
